import { Fragment } from "react";

import Modal from "../../../components/Modal/Modal";
import DefaultContent from "../../../components/Modal/DefaultContent";

type WompiResponseModalProps = {
  closeModal: () => void;
  showWompiResponseModal: boolean;
  wompiPaymentSuccess: boolean;
}

export default function WompiResponseModal({
  closeModal,
  showWompiResponseModal,
  wompiPaymentSuccess,
}: WompiResponseModalProps) {
  return (
    <Fragment>
      <Modal showModal={showWompiResponseModal} closeModal={closeModal}>
        <DefaultContent
          heading={`Transacción ${
            wompiPaymentSuccess ? "aprobada" : "declinada"
          }`}
          label="Pagos Wompi"
          fontAwesomeHeadingIcon={
            wompiPaymentSuccess ? "check-circle" : "times-circle"
          }
          fontAwesomeHeadingIconColor={wompiPaymentSuccess ? "green" : "red"}
          showFooter={false}
        >
          {wompiPaymentSuccess
            ? `Tu pago ha sido exitoso, los productos para realizar tu 
            remodelación están siendo preparados para su entrega.`
            : `Ha ocurrido un problema con tu transacción, por favor intentalo
          de nuevo más tarde o comunicate con nosotros.`}
        </DefaultContent>
      </Modal>
    </Fragment>
  );
}
